import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  switch: {
    marginLeft: '20px',
  },
  infinity: {
    marginLeft: '15px',
    position: 'relative',
    top: '2px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
